import { DefaultSeoProps } from 'next-seo'

export const SEO: DefaultSeoProps = {
  titleTemplate: '%s | DackieSwap',
  defaultTitle: 'DackieSwap',
  description:
    'DackieSwap: #1 Native and Most Trusted DEX on Base. Designed to empower the cryptocurrency community by providing a user-friendly and secure platform, DackieSwap aims to revolutionize the world of decentralized trading.',
  twitter: {
    cardType: 'summary_large_image',
    handle: '@DackieSwap',
    site: '@DackieSwap',
  },
  openGraph: {
    title: 'DackieSwap: #1 Native and Most Trusted DEX on Base',
    description:
      'DackieSwap: #1 Native and Most Trusted DEX on Base. Designed to empower the cryptocurrency community by providing a user-friendly and secure platform, DackieSwap aims to revolutionize the world of decentralized trading.',
    images: [{ url: 'https://dackieswap.xyz/images/dackie_home.jpg' }],
  },
}
